import { render, staticRenderFns } from "./CreateFSAccountPopup.vue?vue&type=template&id=8e85f91c&scoped=true&"
import script from "./CreateFSAccountPopup.vue?vue&type=script&lang=js&"
export * from "./CreateFSAccountPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateFSAccountPopup.vue?vue&type=style&index=0&id=8e85f91c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e85f91c",
  null
  
)

export default component.exports